import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getThemeColors } from '../../../lib/theme';
import { v1Users } from '../../../lib/v1';
import { type MsgRow } from './types';
import { fmtDt } from './helpers';
import { WidgetCard } from './WidgetCard';

/* ─── NachrichtenWidget (compact) ─────────────────────────────────────────── */

export function NachrichtenWidget({ dark, userId, onShowAll }: { dark: boolean; userId: number; onShowAll: (e: React.MouseEvent) => void }) {
  const { t } = useTranslation();
  const tc = getThemeColors(dark);
  const [messages, setMessages] = useState<MsgRow[]>([]);
  const [total, setTotal] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    v1Users.messages(userId, { perPage: 3 })
      .then(p => { if (alive) { setMessages((p.data as unknown as MsgRow[]).slice(0, 3)); setTotal(p.total ?? p.data.length); } })
      .catch(() => {/* ignore */})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [userId]);

  return (
    <WidgetCard dark={dark} title={t('pflege.detail.dashboard.nachrichten')} badge={total} onShowAll={onShowAll} showAllLabel={t('pflege.detail.dashboard.alle_anzeigen')} loading={loading}>
      <div>
        {!loading && messages.length === 0 && (
          <div style={{ padding: '10px 14px', fontSize: 12, color: tc.muted, fontStyle: 'italic' }}>{t('pflege.comm.empty')}</div>
        )}
        {messages.map(m => (
          <div key={m.id} style={{ padding: '8px 14px', borderBottom: `1px solid ${tc.borderSoft}` }}>
            <div style={{ fontSize: 12.5, fontWeight: 500, color: tc.heading, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.betreff ?? t('pflege.comm.no_subject')}</div>
            <div style={{ fontSize: 10.5, color: tc.muted, marginTop: 1 }}>{fmtDt(m.created_at)}</div>
          </div>
        ))}
      </div>
    </WidgetCard>
  );
}
